module.exports = __webpack_public_path__ + "img/payment.59d1b524.jpg";